import styled from 'styled-components'

import { StyledItemContainer } from 'components/Toolbar/ToolbarStyled'

export const StyledContainer = styled.div`
  padding: 20px;
`

export const StyledCompleteContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
`

export const StyledToolbar = styled.div`
  @media(max-width: 740px) {
    ${StyledItemContainer} {
      & > p {
        text-align: left;
      }
      
      & > p:nth-last-of-type(1) {
        text-align: right;
      }
    }
  }
`
